<template>
    <form-row title="Status">
        <input-radio-multi
            name="listing_status"
            :value="listing_detail.listing_status"
            :options="[
                { label: 'New', value: 'new' },
                { label: 'Contingent', value: 'contingent' },
                { label: 'Cancel', value: 'cancel' },
                { label: 'Expired', value: 'expired' },
            ]"
            :nullable="true"
            group_class="flex-wrap"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        listing_detail: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
